const Dropdown = ({
  value,
  options,
  onChange,
  disabled,
  label,
}): React.JSX.Element => (
  // component uses the select tag to build up a dropdown that gets
  // populated by attributes given to it from the parent component
  // ie value, options, onChange, disabled, label
  <select
    className={`form-control ${
      disabled ? "transparent" : "personal-details--input"
    }`}
    value={value}
    onChange={onChange}
    disabled={disabled}
  >
    {/* Display selected country within dropdown */}
    <option value="" disabled hidden>
      {value || label}
    </option>

    {options.map((option, index) => (
      <option key={index} value={option.value}>
        {option.label}
      </option>
    ))}
  </select>
);

export default Dropdown;
